import React from 'react';
import styles from './Footer.module.scss';
import { Container, Row, Col } from 'react-grid-system';
import Image from 'next/image';
import { Text, IconPlace, IconPhone, IconWhats } from 'condolivre-ds';
import { usePartner } from '@/providers/Partner';

const Footer = () => {
    const partner = usePartner();

    return (
        <div className={[styles.footerContainer, 'root-footer'].join(' ')}>
            <Container className={styles.container}>
                <Row>
                    <Col className={[styles.footerText, 'footerText'].join(' ')}>
                        <Image
                            src={partner.root.footer.image.src}
                            width={partner.root.footer.image.width}
                            height={partner.root.footer.image.height}
                        />
                        <Text size="v_16" weight="v_500" color={partner.root.footer.gray_700}>
                            {partner.company.information.line_one} <br />{' '}
                            {partner.company.information.line_two}
                        </Text>
                    </Col>
                </Row>
                <Row>
                    <Col lg={4} className={styles.left}>
                        <Text weight="v_500" color={partner.root.footer.gray_800} size="v_16">
                            Nosso endereço
                        </Text>
                        <Text
                            size="v_14"
                            color={partner.root.footer.gray_800}
                            weight="v_500"
                            className={[styles.tip, styles.address].join(' ')}>
                            <IconPlace />
                            <span>
                                {partner.company.address.line_one} <br />{' '}
                                {partner.company.address.line_two}
                            </span>
                        </Text>
                    </Col>
                    <Col lg={4} className={styles.center}>
                        <Text weight="v_500" color={partner.root.footer.gray_800} size="v_16">
                            Central de atendimento
                        </Text>
                        <Text
                            size="v_24"
                            color={partner.root.footer.gray_800}
                            weight="v_500"
                            className={styles.tip}>
                            <IconPhone />
                            <span>{partner.company.phones.call_center}</span>
                        </Text>
                    </Col>
                    <Col lg={4} className={styles.right}>
                        <Text weight="v_500" color={partner.root.footer.gray_800} size="v_16">
                            Equipe de suporte
                        </Text>
                        <Text
                            size="v_24"
                            color={partner.root.footer.gray_800}
                            weight="v_500"
                            className={styles.tip}>
                            <IconWhats />
                            <span>{partner.company.phones.whatsapp_formatted}</span>
                        </Text>
                    </Col>
                </Row>
            </Container>
        </div>
    );
};

export default Footer;
